import React, { useEffect, useRef } from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toast.scss';
import { useAuthentication } from "meportal/AuthenticationProvider";
import { getOpenEvents } from '../../services/otsEventService';
import { useViewableEventTypes } from "../../providers/ViewEventTypeProvider";
import { useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import { FilterOpenEvents } from '../Sort/SortOtsCards';
import { AuthorizationAccessCheck } from "meportal/AuthorizationProvider";
import { AccessEditButton } from "../../constants/PermissionSet";

interface ToastComponentProps {
    onToastViewClick: (event: any) => void;
}

export const ToastComponent = ({ onToastViewClick } : ToastComponentProps) => {
    function getDateToMinute(date: any) {
        date.setSeconds(0, 0);
        return new Date(date);
      }

    const { userData, getLatestAccessToken } = useAuthentication();
    const eventTypeFilters = useSelector((state) => state.filterSort.filters);
    const viewEventTypes = useViewableEventTypes()?.viewEventTypes;
    const lastCallTime = useRef(getDateToMinute(new Date())); // Store time up to the minute
    const location = useLocation();

    const notify = (category: string, event: any) =>
        toast(<CustomToast category={category} info={event} />, {
        className: category == "overdue" ?"Overdue-toast":'success-toast',
        position: "top-center",
        autoClose:7000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        pauseOnFocusLoss: false,
        draggable: true,
        progress: undefined,
    });

    const CustomToast = ({ category, info }) => (
        <div className="toast_container">
            {category =="within 5 mins" &&<svg className="alert-svg" width="36" height="35" viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="fluent:warning-32-filled">
                    <path id="Vector" d="M17.8725 4.07094C16.6238 1.81156 13.3763 1.81156 12.1275 4.07094L2.29034 21.8825C1.08284 24.0687 2.66534 26.75 5.16284 26.75H24.8382C27.3357 26.75 28.9182 24.0687 27.7097 21.8825L17.8725 4.07094ZM16.1719 21.125C16.1719 21.4358 16.0484 21.7339 15.8287 21.9536C15.6089 22.1734 15.3108 22.2969 15 22.2969C14.6892 22.2969 14.3912 22.1734 14.1714 21.9536C13.9516 21.7339 13.8282 21.4358 13.8282 21.125C13.8282 20.8142 13.9516 20.5161 14.1714 20.2964C14.3912 20.0766 14.6892 19.9531 15 19.9531C15.3108 19.9531 15.6089 20.0766 15.8287 20.2964C16.0484 20.5161 16.1719 20.8142 16.1719 21.125ZM15 8.9375C15.2487 8.9375 15.4871 9.03627 15.6629 9.21208C15.8388 9.3879 15.9375 9.62636 15.9375 9.875V17.375C15.9375 17.6236 15.8388 17.8621 15.6629 18.0379C15.4871 18.2137 15.2487 18.3125 15 18.3125C14.7514 18.3125 14.5129 18.2137 14.3371 18.0379C14.1613 17.8621 14.0625 17.6236 14.0625 17.375V9.875C14.0625 9.62636 14.1613 9.3879 14.3371 9.21208C14.5129 9.03627 14.7514 8.9375 15 8.9375Z" fill="#DE750C" />
                </g>
            </svg>}
            {category == "overdue" && <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g id="Alert/Filled/warning-filled">
                    <path id="warning-filled" fillRule="evenodd" clipRule="evenodd" d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12 15.5C11.5858 15.5 11.25 15.8358 11.25 16.25C11.25 16.6642 11.5858 17 12 17C12.4142 17 12.75 16.6642 12.75 16.25C12.75 15.8358 12.4142 15.5 12 15.5ZM12 7C11.6203 7 11.3065 7.28215 11.2568 7.64823L11.25 7.75V14L11.2568 14.1018C11.3065 14.4678 11.6203 14.75 12 14.75C12.3797 14.75 12.6935 14.4678 12.7432 14.1018L12.75 14V7.75L12.7432 7.64823C12.6935 7.28215 12.3797 7 12 7Z" fill="#DB0B00" />
                </g>
            </svg>}
            <div className="toast_box">
                <div className="toast_content">
                    <p className="toast_heading">{`${info.AircraftRegistration} ${info.AdviseTimeUTC == undefined ? "ETR" : "ADV"} ${category =="overdue"?"is overdue":"overdue in 5m"}`}
                    </p>
                    <p className="problem_statement">{info.ProblemText}</p>
                </div>
                <AuthorizationAccessCheck eventId={info?.Airline+":"+info?.EventType} permission={AccessEditButton}>
                    <div className="view" onClick={() => onToastViewClick(info)} role="button"
                        tabIndex={0} onKeyDown={(e)=> {if(e.key === 'Enter') { onToastViewClick(info) }}}>View</div>
                </AuthorizationAccessCheck>    
            </div>
            <div className="cross_mark">
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector (Stroke)" fillRule="evenodd" clipRule="evenodd" d="M0.792893 0.292893C1.18342 -0.0976311 1.81658 -0.0976311 2.20711 0.292893L8.5 6.58579L14.7929 0.292893C15.1834 -0.0976311 15.8166 -0.0976311 16.2071 0.292893C16.5976 0.683417 16.5976 1.31658 16.2071 1.70711L9.91421 8L16.2071 14.2929C16.5976 14.6834 16.5976 15.3166 16.2071 15.7071C15.8166 16.0976 15.1834 16.0976 14.7929 15.7071L8.5 9.41421L2.20711 15.7071C1.81658 16.0976 1.18342 16.0976 0.792893 15.7071C0.402369 15.3166 0.402369 14.6834 0.792893 14.2929L7.08579 8L0.792893 1.70711C0.402369 1.31658 0.402369 0.683417 0.792893 0.292893Z" fill="#0074C8" />
                </svg>

            </div>
        </div>
    );

    useEffect(() => {
        const callApiAndProcess = () => {
            try{
                if(userData && Array.isArray(viewEventTypes) && viewEventTypes.length > 0 && document.visibilityState === 'visible') { //not generating toast when tab is not visible as we need to only show toast at that particular time
                    const now = getDateToMinute(new Date()); // Get current time up to the minute
                    if (now.getTime() !== lastCallTime.current.getTime()) { //minute changed
                        lastCallTime.current = now;
                        //call api to get open events
                        getLatestAccessToken().then((token) => {
                            userData.access_token = token;
                            getOpenEvents(userData, "", false).then((otsData: any) => {
                                if(otsData && otsData.length > 0) {
                                    //Filter on selected filters of event type
                                    let filteredEvents = FilterOpenEvents(eventTypeFilters, otsData);
                                    //filter on the viewable event types
                                    let viewableOtsEvents = filteredEvents.filter((aircraft: any) => viewEventTypes.some((viewableEventType: any) => viewableEventType.Name === aircraft.EventType));
                                    processToasts(viewableOtsEvents, now);
                                }
                            });
                        });
                    }
                }
            }
            catch(e){
                console.error("Error in processing toast",e);
            }
            finally{
                timeoutId = setTimeout(callApiAndProcess, 1000); 
            }
        };
    
        let timeoutId = setTimeout(callApiAndProcess, 1000); // Check every second

        // Clear the timeout when the component is unmounted
        return () => clearTimeout(timeoutId);
    }, [userData, viewEventTypes, eventTypeFilters]);

    const processToasts = (viewableOtsEvents: any[], now: any) => {
        const fiveMinsFromNow = new Date(now.getTime() + 5 * 60 * 1000); // five mins from now
        
        viewableOtsEvents.forEach((event: any) => {
            let advTime = event.AdviseTimeUTC ? getDateToMinute(new Date(event.AdviseTimeUTC)) : null;
            let etrTime = event.EstimatedReturnToServiceTimeUTC ? getDateToMinute(new Date(event.EstimatedReturnToServiceTimeUTC)) : null;
            
            // Check if event is now overdue or within 5 minutes
            if ((advTime && now.getTime() === advTime.getTime()) || 
                (etrTime && now.getTime() === etrTime.getTime())) {
                notify("overdue",event);
            }
            else if ((advTime && fiveMinsFromNow.getTime() === advTime.getTime()) || 
                    (etrTime && fiveMinsFromNow.getTime() === etrTime.getTime())) {
                    notify("within 5 mins",event);
            }
            
        });
    };

    useEffect(() => {
        toast.dismiss();
    }, [location.pathname]);

    return (
        <></>
    );
};